import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { applyCabine, DEFAULT_CABINE } from '../config/cabines';

/** Applique la cabine du membre dès que son profil est connu. */
const CabineApplier = () => {
  const { user, api } = useAuth();
  const cabine = user?.cabine;

  useEffect(() => {
    if (cabine) {
      applyCabine(cabine);
      return;
    }
    // Repli : si /auth/me ne porte pas la cabine, on la demande directement
    let cancelled = false;
    api.get('/cabines')
      .then((res) => {
        if (!cancelled) applyCabine(res.data?.current || DEFAULT_CABINE);
      })
      .catch(() => applyCabine(DEFAULT_CABINE));
    return () => { cancelled = true; };
  }, [cabine, api]);

  return null;
};

export default CabineApplier;
